import styled from '@emotion/styled';
import BaseText from 'components_2/textStyles/BaseText';

const WorkshopDetailsMainContainer = styled.div`
  max-width: 1007px;
  width: 100%;
  margin: auto;
`;

export const WorkshopTitleContainer = styled.h1`
  color: var(--neutral-700);
  font-size: 48px;
  line-height: 58px;
  letter-spacing: -0.02em;
  font-weight: 700;
`;

export const WorkshopMobileTitleContainer = styled.h1`
  color: var(--neutral-700);
  font-size: 28px;
  line-height: 34px;
  font-weight: 700;
`;

export const PublisherStyledName = styled.h2`
  font-family: 'JennaSue' !important;
  font-size: 36px;
  line-height: 24px;
  color: var(--neutral-700);
  transform: rotate(-1deg);
  font-weight: 400;
`;

export const SwiperCarouselContainer = styled.div`
  width: 100%;

  @media (max-width: 600px) {
    overflow: hidden;
  }
`;

export const SwiperContainer = styled.div`
  width: 100%;

  & .swiper-container .styled-arrow,
  & .swiper-container .styled-arrow:hover {
    border-radius: 10px;
    background-color: var(--neutral-100);
    width: 36px;
    height: 36px;

    svg {
      fill: var(--neutral-600);
      width: 30px;
      height: 30px;
    }
  }
`;

export const SwiperMobileContainer = styled(SwiperContainer)`
  & .swiper-container .swiper-button-next {
    right: 15px;
  }

  & .swiper-container .swiper-button-prev {
    right: 60px;
  }
`;

export const FeaturedWorkshopTitle = styled(BaseText)`
  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 23px;
    font-weight: 700;
  }
`;

export const Divider = styled.hr`
  height: 1px;
  background-color: #e6e8e8;
  border: none;
  margin: 0;
`;

export const MobileDivider = styled.hr`
  height: 1px;
  background-color: #eff3f3;
  border: none;
  margin: 0;
`;

export default WorkshopDetailsMainContainer;
